module.exports = __webpack_public_path__ + "media/Images/icon-rising-graph-o-36df912cd6539e21483e556aaab200a5.svg";